// The add to cart functionality has been commented out as it is now on a separate page

if (!customElements.get('wallpaper-calculator')) {
  customElements.define(
    'wallpaper-calculator',
    class WallpaperCalculator extends HTMLElement {
      constructor() {
        super();
        this.sectionId = this.dataset.sectionId;

        this.wallpaperContainer = this.querySelector('.wallpaper');

        this.wallsContainer = this.querySelector('.walls');
        this.windowsDoorsContainer = this.querySelector('.windows-doors');
        this.addWallButton = this.querySelector('[data-add-wall]');
        this.addWindowDoorButton = this.querySelector('[data-add-window-door]');

        this.addWastageCheckbox = this.querySelector('#wastage');
        this.resultsContainer = this.querySelector('.calculator-result');

        // this.addToCartButton = this.querySelector('[data-add-to-cart]');
        // this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        // this.quantity = 0;

        // this.addToCartButton.addEventListener('click', this.handleAddToCartClick.bind(this));

        this.addWallButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.addWallRow();
        });

        this.addWindowDoorButton.addEventListener('click', (e) => {
          e.preventDefault();
          this.addWindowDoorRow();
        });
        this.addEventBindings();

        this.PLUS_SVG = `<span class='svg-wrapper'><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-plus" viewBox="0 0 10 10"><path fill="currentColor" fill-rule="evenodd" d="M1 4.51a.5.5 0 0 0 0 1h3.5l.01 3.5a.5.5 0 0 0 1-.01V5.5l3.5-.01a.5.5 0 0 0-.01-1H5.5L5.49.99a.5.5 0 0 0-1 .01v3.5l-3.5.01z" clip-rule="evenodd"/></svg></span>`;
        this.MINUS_SVG = `<span class='svg-wrapper'><svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-minus" viewBox="0 0 10 2"><path fill="currentColor" fill-rule="evenodd" d="M.5 1C.5.7.7.5 1 .5h8a.5.5 0 1 1 0 1H1A.5.5 0 0 1 .5 1" clip-rule="evenodd"/></svg></span>`;
      }
      get variantId() {
        return this.dataset.variantId;
      }
      get loadingSpinner() {
        return this.querySelector('.loading__spinner');
      }
      // handleAddToCartClick(e) {
      //   e.preventDefault();
      //   if (this.addToCartButton.classList.contains('loading')) return;

      //   this.addToCartButton.classList.add('loading');
      //   if (this.loadingSpinner) {
      //     this.loadingSpinner.classList.remove('hidden');
      //   }

      //   const config = fetchConfig('javascript');
      //   config.headers['X-Requested-With'] = 'XMLHttpRequest';
      //   delete config.headers['Content-Type'];

      //   const formData = new FormData();
      //   formData.append('id', this.variantId);
      //   formData.append('quantity', this.quantity);
      //   if (this.cart) {
      //     formData.append(
      //       'sections',
      //       this.cart.getSectionsToRender().map((section) => section.id)
      //     );
      //     formData.append('sections_url', window.location.pathname);
      //     this.cart.setActiveElement(document.activeElement);
      //   }
      //   config.body = formData;

      //   fetch(`${routes.cart_add_url}`, config)
      //     .then((response) => response.json())
      //     .then((response) => {
      //       if (!this.cart) {
      //         window.location = window.routes.cart_url;
      //         return;
      //       }
      //       publish(PUB_SUB_EVENTS.cartUpdate, {
      //         source: 'product-form',
      //         productVariantId: formData.get('id'),
      //         cartData: response,
      //       });

      //       const quickAddModal = this.closest('quick-add-modal');
      //       if (quickAddModal) {
      //         document.body.addEventListener(
      //           'modalClosed',
      //           () => {
      //             setTimeout(() => {
      //               this.cart.renderContents(response);
      //             });
      //           },
      //           { once: true }
      //         );
      //         quickAddModal.hide(true);
      //       } else {
      //         this.cart.renderContents(response);
      //       }
      //     })
      //     .catch((e) => {
      //       console.error(e);
      //     })
      //     .finally(() => {
      //       this.addToCartButton.classList.remove('loading');
      //       if (this.loadingSpinner) {
      //         this.loadingSpinner.classList.add('hidden');
      //       }
      //     });
      // }
      calculate() {
        let wallpaperHeightContainer = this.wallpaperContainer.querySelector('input[name="paper-height"]');
        let wallpaperHeight = wallpaperHeightContainer.value;
        let wallpaperWidthContainer = this.wallpaperContainer.querySelector('input[name="paper-width"]');
        let wallpaperWidth = wallpaperWidthContainer.value;
        let coverage = parseFloat(wallpaperHeight) * parseFloat(wallpaperWidth);

        let walls = this.wallsContainer.querySelectorAll('[data-wall-row]');
        let calculatedArea = 0;
        let totalWallArea = 0;
        walls.forEach((wall) => {
          let inputs = wall.querySelectorAll('input');
          let area = parseFloat(inputs[0].value) * parseFloat(inputs[1].value);
          totalWallArea += area;
        });
        let windows = this.windowsDoorsContainer.querySelectorAll('[data-window-door-row]');
        let totalWindowArea = 0;
        windows.forEach((window) => {
          let inputs = window.querySelectorAll('input');
          let area = parseFloat(inputs[0].value) * parseFloat(inputs[1].value);
          totalWindowArea += area;
        });
        totalWallArea = totalWallArea < 1 ? 0 : totalWallArea;
        totalWindowArea = totalWindowArea < 1 ? 0 : totalWindowArea;
        calculatedArea = totalWallArea - totalWindowArea;
        calculatedArea = calculatedArea < 1 ? 0 : calculatedArea;

        this.resultsContainer.classList.add('hidden');
        let originalArea = null;
        if (this.addWastageCheckbox.checked) {
          originalArea = calculatedArea;
          calculatedArea *= 1.1;
        }
        //console.log('calc area ' + calculatedArea);
        //console.log('coverage ' + coverage);
        let needed = Math.ceil(calculatedArea / coverage);
        //console.log('needed ' + needed);

        if (needed > 0) {
          this.resultsContainer.classList.remove('hidden');
          this.resultsContainer.querySelector('[data-calculator-result-area]').innerHTML = `${
            this.addWastageCheckbox.checked
              ? `${originalArea} m<sup>2</sup> (+ 10% wastage)`
              : `${calculatedArea} m<sup>2</sup>`
          } `;

          this.resultsContainer.querySelector('[data-calculator-result-number]').textContent = `${needed} ${
            needed == 1 ? 'roll' : 'rolls'
          }`;

          // this.addToCartButton.querySelector('.text').innerText = `Add ${needed} ${
          //   needed == 1 ? 'roll' : 'rolls'
          // } to Basket`;
          // this.quantity = needed;
        }
      }
      removeEventBindings() {
        let allInputs = this.querySelectorAll(
          '[data-paper-row] input, [data-wall-row] input, [data-window-door-row] input, .calculator-options input'
        );
        allInputs.forEach((input) => {
          input.removeEventListener('change', this.calculate.bind(this));
        });
      }
      addEventBindings() {
        this.removeEventBindings();

        let allInputs = this.querySelectorAll(
          '[data-paper-row] input, [data-wall-row] input, [data-window-door-row] input, .calculator-options input'
        );
        allInputs.forEach((input) => {
          input.addEventListener('change', this.calculate.bind(this));
        });
      }
      addWallRow() {
        let wallRows = this.wallsContainer.querySelectorAll('.wall-row');
        let numberOfWalls = wallRows.length;
        let newWallNumber = numberOfWalls + 1;
        let newRow = document.createElement('fieldset');
        newRow.classList.add('wall-row');
        newRow.setAttribute('data-wall-row', '');
        let newWallRowHTML = `
      <legend class='calculator-heading visually-hidden'>Wall ${newWallNumber}</legend>
       <h4 class='calculator-heading text-body'>Wall ${newWallNumber}</h4>
        <label class='calculator-label' for='wall-${newWallNumber}-width'>Height (m)</label>
        <label class='calculator-label' for='wall-${newWallNumber}-height'>Width (m)</label>
        <quantity-input class="quantity">
          <button class="quantity__button no-js-hidden" name="minus" type="button">
            <span class="visually-hidden">
              Decrease Value For Width
            </span>
            ${this.MINUS_SVG}
          </button>
          <input
            class="quantity__input"
            type="number"
            min="0"
            value="0"
            name='wall-${newWallNumber}-width'
            id='wall-${newWallNumber}-width'
          >
          <button class="quantity__button no-js-hidden" name="plus" type="button">
            <span class="visually-hidden">
              Increase Value For Width
            </span>
            ${this.PLUS_SVG}
          </button>
        </quantity-input>
        <quantity-input class="quantity">
          <button class="quantity__button no-js-hidden" name="minus" type="button">
            <span class="visually-hidden">
              Decrease Value For Height
            </span>
            ${this.MINUS_SVG}     
          </button>
          <input
            class="quantity__input"
            type="number"
            min="0"
            value="0"
            name='wall-${newWallNumber}-height'
            id='wall-${newWallNumber}-height'
          >
          <button class="quantity__button no-js-hidden" name="plus" type="button">
            <span class="visually-hidden">
              Increase Value For Height
            </span>
            ${this.PLUS_SVG}
          </button>
        </quantity-input>
      `;
        newRow.innerHTML = newWallRowHTML;
        this.wallsContainer.appendChild(newRow);
        this.addEventBindings();
      }
      addWindowDoorRow() {
        let windowRows = this.windowsDoorsContainer.querySelectorAll('.window-door-row');
        let numberOfWindowss = windowRows.length;
        let newWindowNumber = numberOfWindowss + 1;
        let newRow = document.createElement('div');
        newRow.classList.add('window-door-row');
        newRow.setAttribute('data-window-door-row', '');
        newRow.innerHTML = `
      <span class='calculator-heading'>Window/Door ${newWindowNumber} (area subtracted from result)</span>
        <label class='calculator-label' for='window-door-${newWindowNumber}-width'>Height (m)</label>
        <label class='calculator-label' for='window-door-${newWindowNumber}-height'>Width (m)</label>
        <quantity-input class="quantity">
          <button class="quantity__button no-js-hidden" name="minus" type="button">
            <span class="visually-hidden">
              Decrease Value For Width
            </span>
            ${this.MINUS_SVG}
          </button>
          <input
            class="quantity__input"
            type="number"
            min="0"
            value="0"
            name='window-door-${newWindowNumber}-width'
            id='window-door-${newWindowNumber}-width'
          >
          <button class="quantity__button no-js-hidden" name="plus" type="button">
            <span class="visually-hidden">
              Increase Value For Width
            </span>
            ${this.PLUS_SVG}
          </button>
        </quantity-input>
        <quantity-input class="quantity">
          <button class="quantity__button no-js-hidden" name="minus" type="button">
            <span class="visually-hidden">
              Decrease Value For Height
            </span>
            ${this.MINUS_SVG}        
          </button>
          <input
            class="quantity__input"
            type="number"
            min="0"
            value="0"
            name='window-door-${newWindowNumber}-height'
            id='window-door-${newWindowNumber}-height'
          >
          <button class="quantity__button no-js-hidden" name="plus" type="button">
            <span class="visually-hidden">
              Increase Value For Height
            </span>
            ${this.PLUS_SVG}
          </button>
        </quantity-input>
      `;
        this.windowsDoorsContainer.appendChild(newRow);
        this.addEventBindings();
      }
    }
  );
}
